import { Text } from '~/components/typography';
import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

export const BudgetBillingCheckbox = (props: InputComponentProps) => {
  const validate = () => {
    return true;
  };
  return (
    <ValidatingInput type="checkbox" label="" name="budgetBilling" validate={validate} {...props}>
      <Text textStyle="paragraph400" color="secondary">
        Are you currently participating in budget billing plan with dominion?
      </Text>
    </ValidatingInput>
  );
};
